var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 font-weight-bold mb-2"},[_vm._v("Account")]),_c('v-card',{attrs:{"rounded":"xl","outlined":""}},[_c('v-card-text',[_vm._v(" Guest mode for now. Later we add login, order history, logout. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }